import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ContactService } from '../../Services/contacts.service';
import { SocialLoginService } from '../../Services/social-login.service';
import { BaseComponent } from '../../Base/base/base.component';
import { finalize, takeUntil } from 'rxjs';
export interface Contact {
  id: string;
  contactId: string;
  displayName: string;
  givenName: string;
  middleName: string;
  familyName: string;
  prefix: string;
  suffix: string;
  phones: string[] | null;
  emails: string[] | null;
  addresses: string | null;
  userId: string;
  notes: string;
  urls: string[];
  organization: string;
  birthday: {
    Day: number;
    Month: number;
    Year: number;
  } | null;
}

@Component({
  selector: 'app-usercontacts',
  templateUrl: './usercontacts.component.html',
  styleUrls: ['./usercontacts.component.css'],
  standalone: false
})
export class UsercontactsComponent extends BaseComponent implements OnInit {
  contacts: any[] = []
  myContacts: any[] = []
  loading: boolean = false;
  userId: string
  userRole!: string
  platform: string = ''
  pendingContacts: any[] = []
  pageNumber: number = 1;
  canGoNext = false;
  canGoPrev = false;
  constructor(private contactService: ContactService,
    private messageService: MessageService,
    private auth: AuthService,
    private api: BaseApiService,
    private authSocail: SocialLoginService
  ) {
    super();
    this.userId = this.auth.getUID();
    this.userRole = this.auth.getRoles().toString();
    this.authSocail.Getplarform().then(x => {
      this.platform = x
    });
  }

  async loadContacts() {
    try {
      if (this.platform != "web") {
        
        this.contactService.getContacts().then((rawContacts) => {
          if (rawContacts.length === 0) { return; }
          if(rawContacts.length>0){
            this.contacts = this.contactService.mapContacts(rawContacts);
            this.loading = true
             
            this.api.create("Profile_Service/SyncContact", { userId: this.userId, contactList: JSON.stringify({ key: this.contacts }) }).subscribe((response) => {
              this.loading = false;
              this.GetContacts(this.userId);
              this.GetdataForProcessing(this.userId);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
            }
              , (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
              }
            );
          }
        });

      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Contact Sync Option is only available in app" });
      }
    }
    catch (error) {
    }
  }
  
  ProcessContact(userId: string) {
    if (!userId) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'User ID is required.' });
        return;
    }

    try {
        this.loading = true;

        const payload = { Role: userId.trim() }; // Ensure `userId` is a valid string

        this.api.create("Profile_Service/ProcesssContacts", payload)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe(

          {
            next:(response) => {
              this.loading = false;
              this.GetContacts(userId);
              this.GetdataForProcessing(this.userId);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: response.description });
             },
            error:(error) => {
              this.loading = false;

              let errorMessage = 'An unknown error occurred.';
              if (error.error?.errors) {
                  errorMessage = Object.values(error.error.errors).flat().join(', '); // Extract error details
              } else if (error.message) {
                  errorMessage = error.message;
              }

              this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
          }
          }
        );
    } catch (error) {
        this.loading = false;
    }
  }


  DeleteContact(userId: string) {
    if (!userId) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'contact id is required for deletion' });
        return;
    }

    try {
        this.loading  = true;
        const payload = { Role: userId.trim() }; 
        this.api.delete(`Profile_Service/DeleteSyncContact?id=${payload.Role}`)
        .pipe
        (
            takeUntil(this.destroy$),
            finalize(() => {
                this.loading = false;
            }
          )
        )
        .subscribe(

          {
            next:(response) => {
              this.loading = false;
              this.GetContacts(this.userId);
              this.GetdataForProcessing(this.userId);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: response.description });
             },
             error:(error) => {
              this.loading = false;
              let errorMessage = 'An unknown error occurred.';
              if (error.error?.errors) {
                  errorMessage = Object.values(error.error.errors).flat().join(', '); // Extract error details
              } else if (error.message) {
                  errorMessage = error.message;
              }

              this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
          }

          }
            ,
            
        );
    } catch (error) {
        this.loading = false;
    }
  }

  DeleteAllContact(userId: string) {
    if (!userId) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'contact id is required for deletion' });
        return;
    }

    try {
        this.loading  = true;
        const payload = { Role: userId.trim() }; 
        this.api.delete(`Profile_Service/DeleteMyAllContacts?userId=${payload.Role}`)
        .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
                this.loading = false;
            }
          )
        ).subscribe(
          {
              next:(response) => {
                this.loading = false;
                this.GetContacts(this.userId);
                this.GetdataForProcessing(this.userId);
                this.messageService.add({ severity: 'success', summary: 'Success', detail: response.description });
            },
            error:(error) => {
              this.loading = false;

              let errorMessage = 'An unknown error occurred.';
              if (error.error?.errors) {
                  errorMessage = Object.values(error.error.errors).flat().join(', '); // Extract error details
              } else if (error.message) {
                  errorMessage = error.message;
              }

              this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
          }
          }
            ,
            
        );
    } catch (error) {
        this.loading = false;
    }
  }


  ngOnInit(): void {
    this.GetdataForProcessing(this.userId);
    this.GetContacts(this.userId);
    
  }

  GetdataForProcessing(userId: string) {
    try {
      this.loading = true;
      this.api.read(`Profile_Service/PendingContactForSyncing?userId=${userId}`)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
         {
           next:(response) => {
            this.pendingContacts = response;
            this.loading = false;
    
          }
          ,
          error:(error) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
         }
        
      );
    }

    catch (error) {
    }
  }

  GetContacts(userId: string) {
    try {
      this.loading = true;
      this.api.read(`Profile_Service/GetSyncContactsList?userId=${userId}&pageNumber=${this.pageNumber}`).pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      ).subscribe(
        
         {
           next: (response) => {
            this.myContacts = response;
            this.myContacts = response.map((contact: any) => ({
              ...contact,
              urls: this.parseUrls(contact.urls),
              birthday: this.parseBirthday(contact.birthday)
            }));
            this.canGoNext = response.length === 10;
            this.canGoPrev = this.pageNumber > 1;
            this.loading   = false;
    
          }
          ,
          error:(error) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
         }
      );
    }

    catch (error) {
    }
  }

  goToNext(userId: string) {
    if (this.canGoNext) {
      this.pageNumber++;
      this.GetContacts(userId);
    }
  }
  
  goToPrev(userId: string) {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.GetContacts(userId);
    }
  }
  // Helper function to safely parse `urls`
  parseUrls(urls: any): string[] {
    if (!urls) return []; // If null or undefined, return an empty array
    if (Array.isArray(urls)) return urls; // If already an array, return it
    try {
      const parsed = JSON.parse(urls); // Try parsing it as JSON
      return Array.isArray(parsed) ? parsed : []; // Ensure it's an array
    } catch {
      return []; // Return an empty array if parsing fails
    }
  }

  // Helper function to parse `birthday` safely
  parseBirthday(birthday: any): { Day: number; Month: number; Year: number } | null {
    if (!birthday) return null;
    try {
      return JSON.parse(birthday);
    } catch {
      return null;
    }
  }

}
